import React from "react";
import Heading from "@insightfulscience/atomic-react/Heading";
import Paragraph from "@insightfulscience/atomic-react/Paragraph";
import Link from "@insightfulscience/atomic-react/Link";
import routes from "../../routes";
import ErrorLayout from "./ErrorLayout";

function Error400() {
	return (
		<ErrorLayout>
			<Heading Tag="h1" size="xl" center className="mb-6 text-color-3">
				Bad Request
			</Heading>
			<Paragraph size="s" center className="">
				We’re sorry, you didn’t provide all mandatory inputs or provided data
				was incorrect.
				<br /> <br />
				Please{" "}
				<Link href={routes.external.help} size="s">
					contact us
				</Link>{" "}
				for further assistance.
			</Paragraph>
		</ErrorLayout>
	);
}

export default Error400;
